
<script>
	import { Bar } from 'vue-chartjs'

	export default {
    props: {
      data: {
				required: true, 
				type: Array
			}
		},
		extends: Bar,
	  mounted () {
			// Overwriting base render method with actual data.
	    this.renderChart({
				labels: this.data.map(item => item.label),
	      datasets: [
	        {
	          label: 'Faturamento',
	          fill: false,
	          backgroundColor: '#2F2F4F',
						data: this.data.map(item => {
							var value = item.value;
							return value;
						}).concat([0])
	        }
				],
			},
			{ 
				responsive: true, 
				maintainAspectRatio: false,
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function(tooltipItems) {
							return 'R$ ' + tooltipItems.yLabel.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
						}
					}
				}
			})
	  }
}
 
</script>





// WEBPACK FOOTER //
// src/components/charts/BarChart.vue